import * as actions from './actions';
import * as auditActions from './auditActions';
import * as reportActions from './reportActions';

import * as ActionTypes from './actionTypes';

const Actions = {
  ...actions,
  ...auditActions,
  ...reportActions,
};

export {Actions, ActionTypes};
